export const checkObjectPropertyExist = (
  object: { [key: string]: any },
  property: string,
): boolean => Object.prototype.hasOwnProperty.call(object, property);
